import { actions, inputs, overlays } from '@ecosystem/newron-design-system';
import React, { FormEvent } from 'react';

interface Props {
  isCreateModalGroupPopUp: boolean;
  title: string;
  createMessage: string;
  isSaving: boolean;
  error: string;
  onCancel: () => void;
  onSaveGroup: (e: FormEvent) => void;
  setGroupName: React.Dispatch<React.SetStateAction<string>>;
}

const CreateGroupModal: React.FC<Props> = ({
  isCreateModalGroupPopUp,
  createMessage,
  onCancel,
  isSaving,
  onSaveGroup,
  title,
  setGroupName,
  error,
}) => {
  const { Modal } = overlays;
  const { Button } = actions;
  const { TextInput } = inputs;
  return (
    <Modal isOpen={isCreateModalGroupPopUp} onClose={onCancel}>
      <form onSubmit={onSaveGroup}>
        <Modal.Header>
          <h2>{title}</h2>
        </Modal.Header>
        <Modal.Body>
          <TextInput
            label={'Group Name'}
            testId="group-name-text-input"
            errorMessage={error}
            onChange={(value) => setGroupName(value)}
            placeholder="Enter group name"
            // eslint-disable-next-line jsx-a11y/no-autofocus
            autoFocus={true}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button mode="secondary" disabled={isSaving} onClick={onCancel}>
            Cancel
          </Button>
          <Button type="submit" disabled={isSaving} onClick={() => null}>
            {isSaving ? 'Saving...' : createMessage}
          </Button>
        </Modal.Footer>
      </form>
    </Modal>
  );
};

export default CreateGroupModal;
